import { last } from 'lodash';
import { FindTheLetterInterface, FindTheObjectInterface } from '../providers/GameProvider/types';

const getLastPageNumber = (state): number | undefined => {
  const lastElement: FindTheLetterInterface | FindTheObjectInterface | undefined = last(
    state?.activityData?.pages || []
  );
  return lastElement?.page.pageNumber;
};

const isLastPage = (state): boolean => {
  const lastPageNumber = getLastPageNumber(state);

  return (
    !!lastPageNumber &&
    state?.currentData?.some(
      (eachPage: FindTheLetterInterface | FindTheObjectInterface) =>
        eachPage.page?.pageNumber === lastPageNumber
    )
  );
};

export default isLastPage;
